import {
  hideMessage,
  showAuthLoader,



  userSignIn
} from "actions/Auth";
import ItemPreviewCard from "app/routes/Component/ItemPreviewCard";
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getItemByUidApi } from "../api/util";
import ProcessTable from "../app/routes/Component/process/ProcessTable.";


class ItemPreviewPage extends React.Component {
  constructor() {
    super();
    this.state = {
      item: {},
      isLangInput: false,
      fileList: [],
      process: [],
      error:false,
      selectedProject: null,
      itemLangList: []
    };
  }

  async componentDidMount() {
    const uid = this.props.match.params.uid;

    const result = await getItemByUidApi(uid);
    if (result.status) {
    // //console.log("444444444444444 ", result);
      this.setState({ item: result.data.item, 
        process: result.data.process , 
        projects: this.props.projects ,
         fileList: result.data.fileList ,
          selectedProject: result.data.selectedProject ,
          projectSettings: result.data.projectSettings,
          itemLangList: result.data.itemLangList
        });
        
    }


  }




  render() {
    const { item, selectedProject, process , projects , fileList , projectSettings , itemLangList } = this.state;


    return (
      <div className="app-wrapper" style={{
        height: '100vh',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <div className="content-wrapper" style={{
          flex: 1,
          padding: '20px'
        }}>
          <div className="row justify-content-center mb-3">
            <Link to="/">
              <img
                src={require("assets/images/says_logo/sonLogo2.png")}
                alt="Yaysis"
                title="Sözlük ve Ansiklopedi Yönetim Sistemi"
              />
            </Link>
          </div>

          <h3 className="m-3 text-center text-danger">
            "{item.title}" Madde İşlem Geçmişi
          </h3>

          <ProcessTable
            processList={process}
            isAdmin={false}
            showComment={false}
            classStyle="overflow-auto col-md-12 col-xs-12 col-sm-12"
          />
          
          <h3 className="m-3 text-center text-danger">
            {item.title} Madde Detayı 
          </h3>
          
          <ItemPreviewCard 
            item={item} 
            projectSettings={projectSettings} 
            itemLangList={itemLangList} 
            selectedProject={selectedProject} 
            projects={projects} 
            fileList={fileList} 
            visibility={true} 
            previewRole={""} 
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth , item }) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  const {projects} = item;

  return { loader, alertMessage, showMessage, authUser , projects };
};

export default connect(mapStateToProps, {
  userSignIn,
  hideMessage,
  showAuthLoader,
})(ItemPreviewPage);
